import styled from "styled-components";

export const DocumentRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  border: 1px solid var(--gray-light);
  border-radius: 8px;
  margin-bottom: 8px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const DocumentInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DocumentTitle = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--neutral);
`;

export const DocumentDate = styled.span`
  font-size: 0.8rem;
  color: var(--neutral-light);
  margin-top: 2px;
`;

export const DocumentNotice = styled.p`
  font-size: 0.8rem;
  color: var(--neutral-light);
  margin: 12px 0 0;
`;

export const DocumentButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--primary);
  color: var(--lightest) !important;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.2s ease;

  &:hover {
    background: var(--primary-light);
  }
`;
